import React from 'react'

const SearchFilters = () => {
    return (
        <div>SearchFilters</div>
    )
}

export default SearchFilters